import { AxiosError } from 'axios';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { analytics } from '../../utils/analytics';
import { post } from '../apiService';
import { invalidateProviderByIdCache } from './getProviderById';
type response = {
  status: string;
};

export const updateProviderById = async (
  id?: string | null,
  body?: object,
): Promise<{
  data: response;
  loading: boolean;
}> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }
  if (!id) {
    throw new Error('Provider ID is not available');
  }
  if (!body) {
    throw new Error('Body is not available');
  }
  const url = `resourceMatrix/providers/update?customerId=${customer}&providerId=${id}`;
  let loading = true;
  try {
    const responseData = await post(
      url,
      body as Record<string, unknown>,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    const data = responseData as response;
    invalidateProviderByIdCache(id);
    loading = false;
    analytics.trackEvent('update', 'provider');
    return { data, loading };
  } catch (error) {
    loading = false;
    if (
      error instanceof AxiosError &&
      error.response?.data &&
      typeof error.response.data === 'object' &&
      'message' in error.response.data
    ) {
      throw new Error(
        `Failed to update provider item: ${error.response.data.message}`,
      );
    }
    throw new Error('Failed to update provider item');
  }
};
